export function showCookieConsentModal(i18n) {
    if (document.getElementById('helpscout-cookie-consent-modal')) {
        return;
    }


    const title = i18n.t('Wymagana zgoda na cookies')
    const message = i18n.t('Aby korzystać z czatu pomocy, musisz wyrazić zgodę na cookies. Możesz to zrobić w ustawieniach cookies.')
    const settingsText = i18n.t('Ustawienia cookies')
    const closeText = i18n.t('Zamknij');

    const modal = document.createElement('div');
    modal.className = 'modal fade';
    modal.id = 'helpscout-cookie-consent-modal';
    modal.setAttribute('tabindex', '-1');
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-labelledby', 'helpscout-cookie-consent-title');
    modal.setAttribute('aria-hidden', 'true');

    modal.innerHTML = `
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="helpscout-cookie-consent-title">${title}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="${closeText}">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>${message}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">${closeText}</button>
                    <button type="button" class="btn btn-primary" id="open-cookie-settings">${settingsText}</button>
                </div>
            </div>
        </div>
    `;

    document.body.appendChild(modal);

    const settingsButton = document.getElementById('open-cookie-settings');
    if (settingsButton) {
        settingsButton.addEventListener('click', function() {
            if (typeof jQuery !== 'undefined') {
                jQuery(modal).modal('hide');
            }

            if (typeof window.CookieConsent !== 'undefined' && typeof window.CookieConsent.showPreferences === 'function') {
                window.CookieConsent.showPreferences()
            }
        });
    }

    if (typeof jQuery !== 'undefined') {
        jQuery(modal).modal('show');

        jQuery(modal).on('hidden.bs.modal', function() {
            modal.remove();
        });
    }
}
